module.exports = __webpack_public_path__ + "img/EW.0e6c1122.png";